import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../images/pin_logo.png";
import "./style.scss";
const mainLayout = ({ children, noNavbar, noFooter }) => (
  <Container fluid className="h-100">
    <ToastContainer />
    <Row className="h-100 p-5">
      <Col lg={{ size: 12 }} md={{ size: 12 }} align="right">
        <span>Switch to{"  "}</span>
        <Link
          to="/login"
          className="red-rounded-button"
          style={{ textDecoration: "none" }}
        >
          <i className="material-icons red-button-icon">settings</i>{" "}
          <span className="red-button-text">Admin Settings</span>
        </Link>
      </Col>
      <Row>
        <Col
          lg={{ size: 12 }}
          md={{ size: 12 }}
          className="pb-3"
          align="center"
        >
          <img
            src={Logo}
            alt="logo"
            name="logo"
            className="float"
            style={{ pointerEvents: "none" }}
            width="17%"
          />
        </Col>
      </Row>
      <Col
        className="main-content pb-5 p-0"
        lg={{ size: 12 }}
        md={{ size: 12 }}
        sm="12"
        tag="main"
      >
        {children}
      </Col>
    </Row>
  </Container>
);

mainLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

mainLayout.defaultProps = {
  noNavbar: false,
  noFooter: false,
};

export default mainLayout;
